import request from './request';
import http from './http';

export { default as FetchData } from '../components/FetchData';

export default { request, http };
